import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const AgreementsSettingsPage = withSuspense(
	lazy(async () => await import('./agreements-settings-page.component')),
	PageLoader,
);
